import { EServiceId } from '../../../../../types/reducers/publishTerms';
import { IAddFormPublishTermsResponse } from '../../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { getServices } from '../../getServices';
import { getServiceId } from '../../../../../utils/publishTerms';

export const hasTopOrPremium = (response: IAddFormPublishTermsResponse): boolean => {
  const terms = getServices(response);
  const serviceIds = terms.map(term => getServiceId(term.services));

  return serviceIds.some(id => id === EServiceId.top || id === EServiceId.premium);
};
